import * as React from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate, useRoutes } from "react-router-dom";

import { Paths } from "./constants/paths";
import { Discovery, DimensionsTestingContainer } from "./containers";
import { CreateOnDemandInsightContainer } from "./containers/createOnDemandInsight";
import { WorkbenchContainer } from "./containers/workbench/Workbench";

const routes: RouteObject[] = [
    {
        path: Paths.ON_DEMAND_INSIGHT_CREATION,
        element: <CreateOnDemandInsightContainer />,
    },
    {
        path: Paths.WORKBENCH,
        element: <WorkbenchContainer />,
    },
    {
        path: Paths.HOME,
        element: <Discovery />,
    },
    {
        path: Paths.DISCOVERY,
        element: <Discovery />,
    },
    {
        path: Paths.DIMENSION_TESTING,
        element: <DimensionsTestingContainer />,
    },
    { path: "/*", element: <Navigate to="/" replace /> },
    { path: "*", element: <Navigate to="/" replace /> },
];

const wildcardMatcher = /^#\//;

const RoutePaths: React.FunctionComponent = () => {
    const elements = useRoutes(routes);
    React.useEffect(() => {
        if (!wildcardMatcher.test(window.location.hash)) {
            window.location.hash = "";
        }
    }, [window.location.hash]);
    return elements;
};

export default RoutePaths;
